import { computed } from 'vue';
import { useStore, useRoute } from '@/utils/vue-api';
import { getUrlParam, isWxMiniProgram, checkUndefined } from '@/utils/api';
import { MULTI_TEMPLATES } from '@/store/modules/irstore';

export function useCommonData() {
	const route = useRoute();
	const store = useStore();
	const getIrBaseInfo = computed(() => store.getters.getIrBaseInfo);

	const isYili = computed(() => getIrBaseInfo.value?.code == '600887');
	const isYiliMiniProgram = computed(() => {
		// 进门小程序内的伊利企业号就没有 comein_channel
		const __channel = getUrlParam().comein_channel;
		return !!__channel && isYili.value && isWxMiniProgram;
	});
	const isBly = computed(() => getIrBaseInfo.value?.code == '603605');
	const isBlyMiniProgram = computed(() => {
		const __channel = getUrlParam().comein_channel;
		return !!__channel && isBly.value && isWxMiniProgram;
	});

	const isZmny = computed(() => getIrBaseInfo.value?.code == 601898);

	const comein_channel = localStorage.getItem('channel');
	// 小程序 + 渠道标识 = 三方定制小程序
	const isThirdMiniProgram = computed(() => isWxMiniProgram && !checkUndefined(comein_channel));
	// 没有渠道标识，就是进门小程序
	const isJMMiniProgram = computed(() => isWxMiniProgram && checkUndefined(comein_channel));

	/**
	 * mode
	 * - link 复制链接
	 * - preview 预览
	 * - iframe 实时预览窗口
	 */
	const viewInPreview = computed(() => {
		const { mode = '' } = route.query;
		return mode === 'preview';
	});
	const viewInIframe = computed(() => {
		const { mode = '' } = route.query;
		return mode === 'iframe';
	});

	const isCardTmpl = computed(() => [3, 7].includes(store.getters.getIrPageType));
	const isFlowTmpl = computed(() => store.getters.getIrPageType == 2);
	const isCardMTmpl = computed(() => store.getters.getIrPageType == 7);

	// 仅从语言版本或 pageType 去匹配当前的模板数据，都是不完整的
	// 都不能真正的区分出到底是单页面模板还是多页面模板
	const multiTemplates = MULTI_TEMPLATES.map(v => Number(v));

	// 皓元医药
	const isChemExpress = computed(() => getIrBaseInfo.value?.code == 688131);

	return {
		isYili,
		isYiliMiniProgram,
		isBly,
		isBlyMiniProgram,
		isThirdMiniProgram,
		isJMMiniProgram,
		isZmny,

		viewInPreview,
		viewInIframe,

		isCardTmpl,
		isFlowTmpl,
		multiTemplates,
		isChemExpress,
		isCardMTmpl
	};
}
